import { Component, OnInit } from '@angular/core';
import { AgentLeadNotificationService } from 'src/app/services/agent-lead-notification.service';
import { PendingAgentSession, UserChatHistoryApiResponse } from 'src/app/models/agent-lead-notification.model';

@Component({
  selector: 'app-whatsapp-request',
  templateUrl: './whatsapp-request.component.html',
  styleUrls: ['./whatsapp-request.component.scss']
})
export class WhatsAppRequestComponent implements OnInit {
  sessions: PendingAgentSession[] = [];
  loading = false;
  resumingSessionId: string | null = null;

  selectedChatData: UserChatHistoryApiResponse | null = null;
  selectedAgentId = 0;
  selectedIsReadOnly = false;
  showChatDetail = false;

  constructor(private service: AgentLeadNotificationService) {}

  ngOnInit(): void {
    this.selectedAgentId = +localStorage.getItem('LOGGED_USER_CRMID') || 0;
    this.loadSessions();
  }

  loadSessions(): void {
    this.loading = true;
    this.service.getWhatsAppActiveRequests(this.selectedAgentId).subscribe(
      (res) => {
        this.sessions = (res && res.sessions) ? res.sessions : [];
        this.loading = false;
      },
      () => { this.loading = false; }
    );
  }

  isExited(session: PendingAgentSession): boolean {
    return session.isAgnetExit === true || session.isAgnetExit === 1;
  }

  openSession(session: PendingAgentSession): void {
    if (this.resumingSessionId) { return; }
    this.resumingSessionId = session.session_id;
    this.service.getUserChatHistory({
      Session_Id: session.session_id,
      MobileNumber: session.mobile_number || session.patient_mobile || ''
    }).subscribe(
      (res) => {
        this.resumingSessionId = null;
        this.selectedChatData = res;
        // isReadOnly = true when agent has already exited (view-only)
        this.selectedIsReadOnly = this.isExited(session);
        this.showChatDetail = true;
      },
      () => { this.resumingSessionId = null; }
    );
  }

  closeChatDetail(): void {
    this.showChatDetail = false;
    this.selectedChatData = null;
    this.selectedIsReadOnly = false;
    this.loadSessions();
  }
}
